module.exports = __webpack_public_path__ + "static/media/aptb4.4be54534.jpg";